import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export const QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULES = (unitId?: string) => ['getMyMonitoringUnitSchedules', unitId].filter(Boolean)

const getUnitSchedules = async (unitId: string): Promise<IUnitScheduledModel[]> =>
  axios.get(`/my-monitoring/sites/GetSchedules?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitSchedules

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useMyMonitoringGetUnitSchedules = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_SCHEDULES(unitId),
    queryFn: () => getUnitSchedules(unitId)
  })
